import styles from "./HobClearance.module.scss";

type Props = {
  hobClearance: string;
};

export const HobClearanceUI = ({ hobClearance }: Props) =>
  hobClearance ? (
    <section className={styles.hobClearance}>
      <h2 className={styles.hobClearance__title}>
        Minimum distance between hob & cooker hood required
      </h2>
      {hobClearance}
    </section>
  ) : null;
